<template>
  <router-link
    :to="{ name: 'landing' }"
    class="siteLogo">
    <svg v-if="showElements && $route.name !== 'article'" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 240.9 155.9" style="enable-background:new 0 0 240.9 155.9;" xml:space="preserve">
    <path class="st1" d="M150.8,18c12.2,0,23.1,10.9,23.1,23.1v98.3H75.6c-12.2,0-23.1-10.9-23.1-23.1V18H150.8 M34.6,45.2
      c0-7.7-6.2-13.9-13.9-13.9c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9C28.4,59,34.6,52.8,34.6,45.2 M52.5,31.3
      c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9 M52.5,59c7.7,0,13.9-6.2,13.9-13.9c0-7.7-6.2-13.9-13.9-13.9 M98.1,45.2
      c0-7.7-6.2-13.9-13.9-13.9c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9C91.9,59,98.1,52.8,98.1,45.2 M50.4,72.9
      c0-7.7-6.2-13.9-13.9-13.9c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9C44.2,86.8,50.4,80.6,50.4,72.9 M82.3,72.9
      c0-7.7-6.2-13.9-13.9-13.9c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9C76.1,86.8,82.3,80.6,82.3,72.9 M52.5,86.8
      c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9 M52.5,114.5c7.7,0,13.9-6.2,13.9-13.9c0-7.7-6.2-13.9-13.9-13.9 M95.3,92.3
      c5.2,0,8.8,2.8,8.8,8.5c0,5.7-3.6,8.6-8.8,8.6h-7.4V92.3H95.3 M95.7,113.5c7.6,0,12.8-5,12.8-12.7c0-7.7-5.2-12.6-12.8-12.6H83.5v43
      h4.4v-17.7H95.7 M126.7,107.2c2.1,2.2,2.3,5.9,2.3,9.2c0,3.3-0.2,7-2.3,9.2c-1.3,1.4-3.2,2.2-5.2,2.2c-2,0-3.8-0.8-5.2-2.2
      c-2.1-2.2-2.3-5.9-2.3-9.2c0-3.3,0.2-7,2.3-9.2c1.3-1.4,3.1-2.2,5.2-2.2C123.5,105,125.3,105.8,126.7,107.2 M129.6,128.2
      c2.9-3.1,3.5-7.2,3.5-11.8c0-4.6-0.6-8.8-3.5-11.8c-2-2.1-4.7-3.4-8.2-3.4c-3.5,0-6.2,1.3-8.2,3.4c-2.9,3.1-3.5,7.2-3.5,11.8
      c0,4.6,0.6,8.8,3.5,11.8c2,2.1,4.7,3.4,8.2,3.4C124.9,131.6,127.6,130.2,129.6,128.2 M162.4,107.2c2.1,2.2,2.3,5.9,2.3,9.2
      c0,3.3-0.2,7-2.3,9.2c-1.3,1.4-3.2,2.2-5.2,2.2c-2,0-3.8-0.8-5.2-2.2c-2.1-2.2-2.3-5.9-2.3-9.2c0-3.3,0.2-7,2.3-9.2
      c1.3-1.4,3.1-2.2,5.2-2.2C159.2,105,161.1,105.8,162.4,107.2 M165.4,128.2c2.9-3.1,3.5-7.2,3.5-11.8c0-4.6-0.6-8.8-3.5-11.8
      c-2-2.1-4.7-3.4-8.2-3.4c-3.5,0-6.2,1.3-8.2,3.4c-2.9,3.1-3.5,7.2-3.5,11.8c0,4.6,0.6,8.8,3.5,11.8c2,2.1,4.7,3.4,8.2,3.4
      C160.7,131.6,163.4,130.2,165.4,128.2 M141.4,88.2h-4.2v43h4.2V88.2z M203.7,120.7c0,2.5-0.5,4.2-1.5,5.1c-1.8,1.8-4,2-6.4,2
      c-4.5,0-6.6-1.6-6.6-5.1c0-3.4,2.1-5.3,6.4-5.3h8V120.7z M207.8,131.2V111c0-6.5-3.8-9.9-11.5-9.9c-4.7,0-7.6,1-10.1,4.4l2.8,2.7
      c1.7-2.5,3.5-3.4,7.2-3.4c5.2,0,7.3,2.2,7.3,6.5v2.8h-8.6c-6.4,0-9.9,3.4-9.9,8.6c0,2.4,0.8,4.6,2.1,6c1.8,1.9,4.1,2.7,8.1,2.7
      c3.8,0,5.9-0.8,8.3-3.2v2.8H207.8z M222.5,105c6.2,0,7.1,5.6,7.1,11.4c0,5.8-0.9,11.4-7.1,11.4c-6.2,0-7.2-5.6-7.2-11.4
      C215.3,110.6,216.3,105,222.5,105 M230.4,129c2.9-3,3.5-8,3.5-12.6c0-4.7-0.6-9.6-3.5-12.6c-1.5-1.6-4.1-2.6-7-2.6
      c-3.1,0-5.8,0.7-8.1,3.8V88.2h-4.2v43h4.2v-3.6c2.3,3.1,4.9,3.9,8.1,3.9C226.3,131.6,228.8,130.5,230.4,129 M182.6,88.2h-4.2v43h4.2
      V88.2z"/>
    </svg>

    <svg v-else class="no-mobile" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 240.9 155.9" style="enable-background:new 0 0 240.9 155.9;" xml:space="preserve">
    <path class="st0" d="M150.8,18c12.2,0,23.1,10.9,23.1,23.1v98.3H75.6c-12.2,0-23.1-10.9-23.1-23.1V18H150.8 M34.6,45.2
      c0-7.7-6.2-13.9-13.9-13.9c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9C28.4,59,34.6,52.8,34.6,45.2 M52.5,31.3
      c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9 M52.5,59c7.7,0,13.9-6.2,13.9-13.9c0-7.7-6.2-13.9-13.9-13.9 M98.1,45.2
      c0-7.7-6.2-13.9-13.9-13.9c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9C91.9,59,98.1,52.8,98.1,45.2 M50.4,72.9
      c0-7.7-6.2-13.9-13.9-13.9c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9C44.2,86.8,50.4,80.6,50.4,72.9 M82.3,72.9
      c0-7.7-6.2-13.9-13.9-13.9c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9C76.1,86.8,82.3,80.6,82.3,72.9 M52.5,86.8
      c-7.7,0-13.9,6.2-13.9,13.9c0,7.7,6.2,13.9,13.9,13.9 M52.5,114.5c7.7,0,13.9-6.2,13.9-13.9c0-7.7-6.2-13.9-13.9-13.9"/>
    </svg>
  </router-link>
</template>

<script>

export default {
  props: {
    showElements: {
      type: Boolean,
      default: () => true
    }
  }
}

</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';

.logo-fade {
  opacity: 0;
  transition: all .3s
}

.logo-fade-active {
  opacity: 1;
}

#Livello_1 {
  width: 136px;
}

.rossetto-menu {
  .st0 {
    fill: white;
  }
}

.st0 {
  fill:#0A2F74;
}

.st1 {
  fill:white;
}

.no-mobile {
  display: none;

  @include media(">=large"){
    display: block;
  }
}
</style>
